var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _AudioFileBoxAdapter_terminator, _AudioFileBoxAdapter_context, _AudioFileBoxAdapter_box, _AudioFileBoxAdapter_transientMarkerAdapters, _AudioFileBoxAdapter_transients, _AudioFileBoxAdapter_audioDataPromise;
import { panic, Terminator, UUID } from "@opendaw/lib-std";
import { EventCollection } from "@opendaw/lib-dsp";
import { TransientMarkerBoxAdapter } from "./TransientMarkerBoxAdapter";
import { Promises } from "@opendaw/lib-runtime";
export class AudioFileBoxAdapter {
    constructor(context, box) {
        _AudioFileBoxAdapter_terminator.set(this, new Terminator());
        _AudioFileBoxAdapter_context.set(this, void 0);
        _AudioFileBoxAdapter_box.set(this, void 0);
        _AudioFileBoxAdapter_transientMarkerAdapters.set(this, void 0);
        _AudioFileBoxAdapter_transients.set(this, void 0);
        _AudioFileBoxAdapter_audioDataPromise.set(this, void 0);
        __classPrivateFieldSet(this, _AudioFileBoxAdapter_context, context, "f");
        __classPrivateFieldSet(this, _AudioFileBoxAdapter_box, box, "f");
        __classPrivateFieldSet(this, _AudioFileBoxAdapter_transientMarkerAdapters, UUID.newSet(({ uuid }) => uuid), "f");
        __classPrivateFieldSet(this, _AudioFileBoxAdapter_transients, EventCollection.create(AudioFileBoxAdapter.Comparator), "f");
        __classPrivateFieldSet(this, _AudioFileBoxAdapter_audioDataPromise, Promises.memoizeAsync(async () => {
            if (this.data.nonEmpty()) {
                return this.data.unwrap();
            }
            const { promise, resolve, reject } = Promise.withResolvers();
            const loader = this.getOrCreateLoader();
            const subscription = loader.subscribe(state => {
                if (state.type === "loaded") {
                    queueMicrotask(() => subscription.terminate());
                    resolve(loader.data.unwrap("State mismatch"));
                }
                else if (state.type === "error") {
                    queueMicrotask(() => subscription.terminate());
                    reject(new Error(state.reason));
                }
            });
            return promise;
        }), "f");
        __classPrivateFieldGet(this, _AudioFileBoxAdapter_terminator, "f").ownAll(box.transientMarkers.pointerHub.catchupAndSubscribe({
            onAdded: (pointer) => {
                const marker = __classPrivateFieldGet(this, _AudioFileBoxAdapter_context, "f").boxAdapters.adapterFor(pointer.box, TransientMarkerBoxAdapter);
                if (__classPrivateFieldGet(this, _AudioFileBoxAdapter_transientMarkerAdapters, "f").add(marker)) {
                    __classPrivateFieldGet(this, _AudioFileBoxAdapter_transients, "f").add(marker);
                }
            },
            onRemoved: ({ box: { address: { uuid } } }) => {
                __classPrivateFieldGet(this, _AudioFileBoxAdapter_transients, "f").remove(__classPrivateFieldGet(this, _AudioFileBoxAdapter_transientMarkerAdapters, "f").removeByKey(uuid));
            }
        }));
    }
    get box() { return __classPrivateFieldGet(this, _AudioFileBoxAdapter_box, "f"); }
    get uuid() { return __classPrivateFieldGet(this, _AudioFileBoxAdapter_box, "f").address.uuid; }
    get address() { return __classPrivateFieldGet(this, _AudioFileBoxAdapter_box, "f").address; }
    get startInSeconds() { return __classPrivateFieldGet(this, _AudioFileBoxAdapter_box, "f").startInSeconds.getValue(); }
    get endInSeconds() { return __classPrivateFieldGet(this, _AudioFileBoxAdapter_box, "f").endInSeconds.getValue(); }
    get transients() { return __classPrivateFieldGet(this, _AudioFileBoxAdapter_transients, "f"); }
    get fileName() { return __classPrivateFieldGet(this, _AudioFileBoxAdapter_box, "f").fileName.getValue(); }
    get data() { return this.getOrCreateLoader().data; }
    get peaks() { return this.getOrCreateLoader().peaks; }
    get audioData() { return __classPrivateFieldGet(this, _AudioFileBoxAdapter_audioDataPromise, "f").call(this); }
    getOrCreateLoader() { return __classPrivateFieldGet(this, _AudioFileBoxAdapter_context, "f").sampleManager.getOrCreate(__classPrivateFieldGet(this, _AudioFileBoxAdapter_box, "f").address.uuid); }
    terminate() { __classPrivateFieldGet(this, _AudioFileBoxAdapter_terminator, "f").terminate(); }
}
_AudioFileBoxAdapter_terminator = new WeakMap(), _AudioFileBoxAdapter_context = new WeakMap(), _AudioFileBoxAdapter_box = new WeakMap(), _AudioFileBoxAdapter_transientMarkerAdapters = new WeakMap(), _AudioFileBoxAdapter_transients = new WeakMap(), _AudioFileBoxAdapter_audioDataPromise = new WeakMap();
AudioFileBoxAdapter.Comparator = (a, b) => {
    const difference = a.position - b.position;
    if (difference === 0) {
        console.warn(a, b);
        return panic("Events at the same position: " + a.position + ", " + b.position);
    }
    return difference;
};
